import { createContext as t } from "react";
const e = {
  isDrawerLike: !1
}, r = t(
  e
);
export {
  r as DialogContext
};
//# sourceMappingURL=context.mjs.map
